import {QueryClient} from '@tanstack/react-query';
import {CampaignApprovalStep, CampaignProps} from '@/types/campaign';

function updateCampaignApprovalStepsCache(
  queryClient: QueryClient,
  queryKey: unknown[],
  buildCampaignApprovalSteps: (
    steps: CampaignApprovalStep[]
  ) => CampaignApprovalStep[]
) {
  queryClient.setQueryData(
    queryKey,
    (old: ({data: CampaignProps} & Record<string, unknown>) | undefined) => {
      if (!old) {
        return old;
      }
      return {
        ...old,
        data: {
          ...old.data,
          campaignApprovalSteps: buildCampaignApprovalSteps(
            old.data.campaignApprovalSteps || []
          ),
        },
      };
    }
  );
}

export default updateCampaignApprovalStepsCache;
